import React from 'react'

const ButtonShimmer = ({customHeightWidth}) => {
    return (
        <div className={`${customHeightWidth ? customHeightWidth : "h-[30px] w-20"} py-5 bg-[#DFDFDF] flex items-center rounded-md animate-pulse`}>
        </div>
    )
}

export default ButtonShimmer